"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Check } from "lucide-react";
import { Separator } from "@/components/ui/separator";
export default function WhyChooseUs() {
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const reasons = [{
    id: 1,
    text: "Punctual and Reliable Service"
  }, {
    id: 2,
    text: "Discreet and Privacy-Focused"
  }, {
    id: 3,
    text: "High-Quality Luxury Vehicles"
  }, {
    id: 4,
    text: "Professional and Experienced Drivers"
  }];
  return <section id="why-choose-us" className="relative min-h-[800px] flex items-center overflow-hidden bg-dark-section">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_chauffeur_la_dusk.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_chauffeur_la_dusk.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/luxury_chauffeur_la_dusk.png-wvc-sizes" alt="Luxury Black Car in Los Angeles" className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute inset-0 bg-black/60 backdrop-blur-[1px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10 section-padding">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-6 space-y-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="space-y-4">
              <span className="text-secondary font-semibold tracking-widest uppercase text-sm">Excellence in Motion</span>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
                Redefining Luxury <br />
                <span className="text-secondary">Transportation</span>
              </h2>
            </div>
            
            <p className="text-lg md:text-xl text-white/80 leading-relaxed font-light max-w-xl">
              At Phoenix Enterprises Limousine Service, we redefine luxury transportation in Los Angeles. Our fleet of premium black cars and SUVs, combined with our team of professional chauffeurs, ensures every journey is executed with precision, comfort, and absolute discretion.
            </p>

            <div className="pt-4">
              <Separator className="w-24 bg-secondary h-1" />
            </div>
          </div>

          {}
          <div ref={listRef} className={`lg:col-span-5 lg:col-start-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${listVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="glass-effect p-8 md:p-10 relative overflow-hidden">
              {}
              <div className="absolute inset-0 opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/perforated_leather_texture.png)] bg-repeat pointer-events-none" />
              
              <div className="relative z-10 space-y-8">
                <h3 className="text-2xl font-display font-semibold text-white border-b border-white/10 pb-4">
                  The Phoenix Advantage
                </h3>
                
                <ul className="space-y-6">
                  {reasons.map((reason, i) => <li key={reason.id} data-index={i} className={`flex items-center gap-5 transition-all duration-500 ease-out ${listVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`} style={{
                  transitionDelay: `${i * 150}ms`
                }}>
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-secondary/10 border border-secondary/30 flex items-center justify-center">
                        <Check className="w-5 h-5 text-secondary" />
                      </div>
                      <span className="text-lg text-white/90 font-medium">
                        {reason.text}
                      </span>
                    </li>)}
                </ul>

                <p className="text-sm text-white/60 italic pt-4 border-t border-white/10">
                  Serving Los Angeles & Surrounding Areas with Unmatched Professionalism.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}